import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import 'rxjs/Rx';
import { catchError } from 'rxjs/operators/catchError';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UrlMaker } from 'src/app/commons/url-maker';
import { OperationResult } from '@tb/auth';
import { throwError } from 'rxjs';
import { OTPViaSMSInfo } from 'src/app/model/authenticator';

@Injectable()
export class AuthenticatorService {
    storeApiUrl: string;

    constructor(private http: HttpClient) {
        this.http = http;
        this.storeApiUrl = environment.settings.storeApiUrl;
    }

    getImageOtp(accountName: string) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('totpConfiguration').appendSegment(accountName).toString();

        return this.http
            .get(url, { responseType: 'blob', headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error')));
    }

    validateTOTP(accountName: string, body: string) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('totpValidation').appendSegment(accountName).toString();

        return this.http
            .post<OperationResult>(url, body, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error')));
    }

    disableTOTP(accountName: string) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('totpValidationDisable')
            .appendSegment(accountName)
            .toString();

        return this.http
            .post<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error')));
    }

    otpSMSConfiguration(body: OTPViaSMSInfo) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('otpSMSConfiguration').toString();

        return this.http
            .post<OperationResult>(url, body, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error')));
    }

    validateSMS(body: OTPViaSMSInfo) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('otpSMSValidation')
            .appendSegment(body.AccountName)
            .toString();

        return this.http
            .post<OperationResult>(url, body, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error')));
    }

    disableSMS(accountName: string) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('otpSMSConfigurationDisable')
            .appendSegment(accountName)
            .toString();

        return this.http
            .post<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error')));
    }
}
